import { useState, useCallback } from 'react';
import authService from '../services/authService';

const MAX_LIVE_LOGS = 100;

export const useLiveLogs = () => {

  const [liveLogs,           setLiveLogs]           = useState([]);
  const [loadingLiveLogs,    setLoadingLiveLogs]     = useState(false);
  const [userActivityCounts, setUserActivityCounts]  = useState({});

  /**
   * fetchLiveLogs 
   */
  const fetchLiveLogs = useCallback(async (microservice = null, adminId = null) => {
    setLoadingLiveLogs(true);
    try {
      const data = await authService.getLiveLogsSnapshot(50, microservice, adminId);
      setLiveLogs(data.logs || []);
    } catch (e) {
      console.error('fetchLiveLogs error:', e);
    } finally {
      setLoadingLiveLogs(false);
    }
  }, []);

  const patchActivityCount = useCallback((data) => {
    setUserActivityCounts((prev) => ({
      ...prev,
      [data.user_id]: {
        daily_count:  data.daily_count,
        date:         data.date,
        service_name: data.service_name,
      },
    }));
  }, []);

  const patchStatsCount = useCallback((data) => {
    setUserActivityCounts((prev) => ({
      ...prev,
      [data.user_id]: {
        daily_total:   data.daily_total,
        alltime_total: data.alltime_total,
        date:          data.date,
      },
    }));
  }, []);

  return {
    liveLogs,
    setLiveLogs,
    loadingLiveLogs,
    userActivityCounts,
    fetchLiveLogs,
    patchActivityCount,
    patchStatsCount,
  };
};


